import * as React from 'react';
import { useAdaptable } from '../AdaptableContext';
export const AlertEmptyView = (props) => {
    const adaptable = useAdaptable();
    const accessLevel = adaptable.api.internalApi
        .getEntitlementService()
        .getEntitlementAccessLevelForModule(props.module.moduleInfo.ModuleName);
    const text = accessLevel == 'ReadOnly'
        ? 'You have no Alert Definitions.'
        : "Click 'New' to create a new Alert Definition. The Definition will include the Rule which triggers the Alert, and the behaviour of the Alert.";
    return React.createElement(React.Fragment, null, text);
};
